import { DateTimeFormatter, Instant, LocalDateTime, ZoneId } from "@js-joda/core";
import { useGetRecentData } from "api/api-hooks/datasets-hooks";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { T } from "services/lang/LanguageService";
import { ILastKnownValueTimeMomentProps } from "./LastKnownValueTimeMomentTypes";

export default function LastKnownValueTimeMoment(props: ILastKnownValueTimeMomentProps) {
  const dateFormat = props.dateFormat || "yyyy-MM-dd HH:mm:ss";
  const text = props.customText || "";
  const [userTimeZone, setUserTimeZone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  const [instant, setInstant] = useState<Instant | undefined>();

  const { data, isLoading } = useGetRecentData([props.identifier], {
    options: {
      refetchInterval: props.updateFrequency ? props.updateFrequency * 1000 : 5000,
    },
  });

  const convertDateToFormattedString = (date: LocalDateTime | undefined, formatString: string) => {
    const formatter = DateTimeFormatter.ofPattern(formatString);
    return date?.format(formatter);
  };

  let zonedDateTime;
  try {
    zonedDateTime = instant?.atZone(ZoneId.of(userTimeZone));
  } catch (error) {
    console.error(`Unsupported ZoneId: ${userTimeZone}. Falling back to default time zone.`);
    zonedDateTime = instant?.atZone(ZoneId.of("UTC"));
  }
  const localDateTime = zonedDateTime?.toLocalDateTime();

  useEffect(() => {
    if (data && data[0]?.data[0]?.key) {
      const lastValueTime = data[0]?.data[0]?.key;
      setInstant(Instant.parse(lastValueTime));
    } else {
      setInstant(undefined);
    }
  }, [data]);

  if (isLoading) {
    return <ProgressSpinner />;
  }
  if (!localDateTime) {
    return <div>{T("message.this-dataset-has-no-values")}</div>;
  }
  return (
    <div className="last-value-time-indicator" style={props.style as React.CSSProperties}>
      {text.length > 0 ? `${text}: ` : ""}
      {convertDateToFormattedString(localDateTime, dateFormat)}
    </div>
  );
}
